import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';

export default graphql(
  gql`
    mutation UpdateUserCapabilities($input: UpdateUserCapabilitiesInput!) {
      updateUserCapabilities(input: $input)
    }
  `,
  {
    props: ({ mutate }) => ({
      updateUserCapabilities: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
          })
        );
      },
    }),
  }
);
